export default __webpack_public_path__ + "static/media/GN.aaf04047.ico";